import { render, staticRenderFns } from "./PortfoliosToInvestView.vue?vue&type=template&id=15cf1940&scoped=true&"
import script from "./PortfoliosToInvestView.vue?vue&type=script&lang=ts&"
export * from "./PortfoliosToInvestView.vue?vue&type=script&lang=ts&"
import style0 from "./PortfoliosToInvestView.vue?vue&type=style&index=0&id=15cf1940&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cf1940",
  null
  
)

export default component.exports